<script setup lang="ts"></script>

<template>
  <el-main
    class="tw-h-full tw-p-0 tw-px-10 tw-bg-grey-300 tw-bg-[url(@urgent/assets/img/background.png)] tw-bg-no-repeat tw-bg-cover"
  >
    <div class="tw-h-full tw-flex tw-justify-center tw-items-center">
      <slot />
    </div>
  </el-main>
</template>
